import React, { PureComponent } from 'react';
import { CircularProgress } from 'react-md';
import Index from '../templates/index';
import ContentExperiment from '../components/ContentExperiment/ContentExperiment';
import EmailLookup from '../components/EmailLookup/EmailLookup';
import NotFoundPage from './404';
import TeaserBanner from '../components/TeaserBanner/TeaserBanner';

function getFakeBundleSummary(fromBundle) {
  return {
    ...fromBundle,
    app_name: 'Your App',
    app_url: null,
    bundle_id: 'com.yourcompany.app',
    company: 'Your Company (Sample)',
    management: [],
  };
}

const Wrapper = ({ children }) => (
  <div style={{ margin: '200px auto 50px auto', maxWidth: 600 }}>
    {children}
  </div>
);

export default class IndexPage extends PureComponent {
  render() {
    const sampleReport = () => (
      <div className="sample-report">
        <Index
          {...this.props}
          forceFiveStar
          data={{
            bundleSummary: getFakeBundleSummary(this.props.data.bundleSummary),
          }}
        />
        <TeaserBanner />
      </div>
    );

    return (
      <ContentExperiment
        renderLoading={() => (
          <Wrapper>
            <CircularProgress id="loading" />
          </Wrapper>
        )}
        renderError={() => <NotFoundPage />}
        renderVariations={[
          sampleReport,
          () => (
            <Wrapper>
              <EmailLookup />
            </Wrapper>
          ),
          sampleReport,
        ]}
      />
    );
  }
}

export const pageQuery = graphql`
  query IndexBundleQuery {
    bundleSummary(fields: { bundle_id: { eq: "com.cuofamerica.ios1" } }) {
      ...bundleSummary
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.jsx